import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

import Navbar from "./global-components/navbar-v4";
import PageHeader from "./global-components/page-header";

import CallToActionV1 from "./section-components/call-to-action-v1";
import SponsorV2 from "./section-components/sponsor-v2";
import Footer from "./global-components/footer";

class Privacy extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div>
        <Navbar />
        <PageHeader headertitle="Privacy Policy" />

        <div className="ltn__page-details-area ltn__service-details-area mb-105">
          <div className="container">
            <div className="row">
              <div className="">
                <div className="ltn__page-details-inner ltn__service-details-inner">
                  <h3> Effective Date: 21/10/2026</h3>
                  <p>
                    {" "}
                    This Privacy Policy explains how Quoin Estates Management Ltd,
                    trading as Quoin Management ("we,"
                    "us," or "our") collects, uses, shares, and protects
                    personal information obtained from users ("you" or "your")
                    of the website{" "}
                    <a href="https://www.quoinmanagement.com">https://www.quoinmanagement.com</a> ("Website")
                    and of the Quoin mobile application and online account
                    platform through which tenants, leaseholders, landlords and
                    directors sign in to manage their properties (the
                    "Platform"). The Website and the Platform are together
                    referred to as the "Services". We are committed to
                    safeguarding your privacy and ensuring the security of the
                    personal information you provide to us.
                  </p>
                  <p>
                    {" "}
                    Quoin Management is the data controller for the personal
                    information described in this Policy. Where we manage a
                    property on behalf of a Client Body, as defined below, that
                    body may also be a controller of some of the same
                    information.
                  </p>
                  <ol>
                    <li>Definitions</li>
                    <p>
                      {" "}
                      In this Privacy Policy the following words have the
                      following meanings:
                    </p>
                    <ol>
                      <li>
                        "Website" — the website at
                        https://www.quoinmanagement.com.
                      </li>
                      <li>
                        "Platform" — the Quoin mobile application and the online
                        account through which you sign in to view and manage
                        matters relating to your property.
                      </li>
                      <li>
                        "Services" — the Website and the Platform together.
                      </li>
                      <li>
                        "Role" — the capacity in which you hold an account:
                        tenant, leaseholder, landlord or director. You may hold
                        more than one at the same time, and your Role determines
                        what you are able to see and do.
                      </li>
                      <li>
                        "Property Agreement" — your tenancy agreement, lease,
                        transfer, management agreement or other contract
                        relating to the property.
                      </li>
                      <li>
                        "Client Body" — the landlord, freeholder, residents'
                        management company or right to manage company on whose
                        behalf we manage a property.
                      </li>
                    </ol>
                    <li>Information We Collect</li>
                    <ol>
                      <li>
                        Personal Information: We may collect personal
                        information that you voluntarily provide to us when you
                        visit our Website, register an account, fill out forms,
                        subscribe to our newsletter, or interact with our
                        services. This information may include your name, email
                        address, phone number, postal address, and any other
                        information you choose to provide.
                      </li>
                      <li>
                        Automatically Collected Information: When you visit our
                        Website or use the Platform, we may automatically
                        collect certain information about your device and
                        browsing activity. This information may include your IP
                        address, browser type, device type and operating
                        system, application version, referring URLs, pages and
                        screens visited, actions taken in the Platform, and the
                        dates and times of your visits. We may use cookies, web
                        beacons, and similar tracking technologies to collect
                        this information on the Website. The mobile application
                        does not use cookies, but it does store data locally on
                        your device, including your sign-in session and display
                        preferences.
                      </li>
                      <li>
                        Account Information: When you hold an account on the
                        Platform we process your name, email address (which is
                        also your sign-in username), a securely hashed form of your password, and — where you or we add them — your date
                        of birth, mobile number, profile picture and chosen
                        avatar colour. We also record the Roles you hold
                        (tenant, leaseholder, landlord or director), which
                        determine what you are able to see and do, together with
                        sign-in dates and account activity. We keep a record of
                        changes made to your account details,
                        showing which details were changed, by whom, from where
                        and when; this record does not contain the details
                        themselves.
                      </li>
                      <li>
                        Property and Tenancy Information: We process information
                        about the properties you are connected to, including
                        addresses and postcodes, property photographs, the block
                        or estate a unit sits within, and the details of your
                        tenancy, lease or ownership. For tenancies this includes
                        rent, deposit, payment day, start and end dates,
                        contract dates and management fees.
                      </li>
                      <li>
                        Financial Information: We process the charges raised
                        against you and the payments you make, including service
                        charges, ground rent, rent, instalment and payment plan
                        schedules, amounts outstanding, missed or late payments,
                        payment dates and methods, statements, invoices and
                        receipts. We also display the bank account details of
                        the account you are required to pay into. Where you are
                        a landlord, we process income, expenses, earnings
                        summaries and performance reports for your properties.
                      </li>
                      <li>
                        Payment Card Information: Card and digital wallet
                        payments made through the Platform are processed by our
                        payment provider, Stripe. Your full card details are
                        entered into components operated by Stripe and are sent
                        directly to Stripe — we do not receive or store your
                        full card number. We receive confirmation of the payment
                        and limited details such as the amount, the date and the
                        outcome.
                      </li>
                      <li>
                        Device Identifier: Where you use the mobile app, Stripe
                        also collects a device identifier (the Android or iOS
                        identifier assigned to your device) and sends it to
                        Stripe. This is used to detect and prevent fraudulent
                        payments. It is collected by Stripe's software within the
                        app rather than by us; we do not use it to track you
                        across other apps or websites; and it is not an
                        advertising identifier.
                      </li>
                      <li>
                        Documents: We hold and make available to you documents
                        relating to your property and account, such as
                        statements, invoices, receipts, tenancy and lease
                        documents, certificates and reports. Where you ask us to
                        email a document to an address other than your own, we
                        process that email address and a one-time verification
                        code in order to confirm that the request is genuine.
                      </li>
                      <li>
                        Maintenance, Service and Enquiry Information: When you
                        raise a maintenance request, purchase or request a
                        service, or contact us through the Platform, we process
                        the category and description of your request, the
                        property it concerns, any messages exchanged, the status
                        and dates of the request, the costs incurred, and the
                        response given by our staff.
                      </li>
                      <li>
                        Compliance Information: Where you are a landlord or
                        director, we process compliance records for your
                        properties, such as gas safety certificates, electrical
                        installation condition reports and energy performance
                        certificates, together with the dates on which they were
                        obtained and expire.
                      </li>
                      <li>
                        Community Information: We process your responses to
                        polls and consultations, your responses to and
                        attendance at calendar events and meetings, and your
                        interaction with announcements. We keep a record of the
                        notifications we send you about calendar events, showing
                        what was sent, when and how. Your vote is recorded
                        against your account so that each person may vote once
                        and so that only eligible residents vote; poll results
                        are made available to residents as totals only and we do
                        not disclose to other residents how any individual
                        voted.
                      </li>
                    </ol>
                    <li>Information We Receive from Others</li>
                    <p>
                      {" "}
                      Some of the information we hold about you is not provided
                      by you directly. We may receive your details from the
                      landlord, freeholder, residents' management company, right
                      to manage company, developer, letting agent or solicitor
                      connected to your property, so that we can set up your
                      account and administer your tenancy, lease or ownership.
                      We may also receive information from contractors who carry
                      out work at your property and from our payment provider.
                    </p>
                    <li>Use of Information</li>
                    <ol>
                      <li>
                        Provision of Services: We use the information we collect
                        to provide and improve our services, respond to your
                        enquiries, process transactions, and communicate with
                        you. This includes sending you important information
                        about your account, updates, newsletters, and
                        promotional materials related to our services.
                      </li>
                      <li>
                        Operating Your Account: We use your information to
                        create and administer your Platform account, to
                        authenticate you when you sign in, to determine which
                        properties, documents, charges and features you are
                        entitled to see in each of your Roles, and to keep your
                        session secure.
                      </li>
                      <li>
                        Managing Your Property: We use your information to
                        administer your tenancy, lease or ownership, to raise
                        and collect charges and process payments, to produce
                        statements, invoices, receipts and reports, to handle
                        maintenance and service requests and instruct
                        contractors, to run consultations, polls and meetings,
                        to issue announcements, to tell you by email and app
                        notification about calendar events at your property —
                        new events, changes, cancellations and reminders — which
                        you can turn off in your notification settings, and to
                        monitor and evidence
                        compliance with health, safety and other legal
                        obligations.
                      </li>
                      <li>
                        Security and Prevention of Misuse: We use account and
                        device information to protect the Services, to detect
                        and prevent unauthorised access, fraud and abuse, and to
                        investigate incidents.
                      </li>
                      <li>
                        We process your personal information based on your
                        consent, the necessity of fulfilling our contractual
                        obligations, compliance with legal obligations, and our
                        legitimate interests in providing and improving our
                        services and maintaining the security of our Website and
                        the Platform. Where we rely on legitimate interests,
                        those interests are the effective management of the
                        properties in our care, the recovery of sums properly
                        due, and the security and improvement of the Services.
                      </li>
                    </ol>

                    <li>Information Sharing</li>
                    <ol>
                      <li>
                        Third-Party Service Providers: We may engage trusted
                        third-party service providers to assist us in operating
                        our Website and the Platform and delivering our
                        services. These include cloud hosting and infrastructure
                        providers, our payment provider (Stripe), email and
                        messaging delivery providers, and providers of
                        accountancy, document management and IT support. These
                        service providers may have access to your personal
                        information only to perform tasks on our behalf and are
                        obliged to protect and handle your information in
                        accordance with this Privacy Policy.
                      </li>
                      <li>
                        Parties Connected to Your Property: We may share your
                        information with the Client Body and its appointed
                        directors, with other agents acting for it, and with its
                        accountants, auditors, insurers, surveyors and
                        solicitors, where this is necessary to manage the
                        property or to comply with the terms of your Property
                        Agreement. We also share the information a
                        contractor needs in order to attend your property and
                        carry out works you or we have requested.
                      </li>
                      <li>
                        Business Transfers: In the event of a merger,
                        acquisition, or sale of all or a portion of our assets,
                        your personal information may be transferred to the
                        acquiring entity. We will notify you by email or by a
                        prominent notice on our Website before your personal
                        information is transferred and becomes subject to a
                        different privacy policy.
                      </li>
                      <li>
                        Legal Requirements: We may disclose your personal
                        information if required by law, court order, or
                        government regulation, or if we believe such disclosure
                        is necessary to protect our rights, property, or safety,
                        or the rights, property, or safety of others. This
                        includes disclosure to the police, local authorities,
                        regulators, tribunals and courts, and to debt recovery
                        agents where sums remain unpaid.
                      </li>
                      <li>
                        We do not sell your personal information, and we do not
                        share it with third parties for their own marketing
                        purposes.
                      </li>
                    </ol>
                    <li>Data Retention</li>
                    <p>
                      {" "}
                      We retain your personal information for as long as
                      necessary to fulfil the purposes outlined in this Privacy
                      Policy, unless a longer retention period is required or
                      permitted by law. In general, we keep account, tenancy,
                      lease, financial and payment records for the duration of
                      your relationship with the property and for a further
                      period afterwards to meet our accounting, tax and legal
                      obligations and to allow for the resolution of disputes.
                      In practice this means:
                    </p>
                    <ol>
                      <li>
                        Account, tenancy, lease, financial and payment records:
                        six years from the end of your tenancy, lease or account
                        with us. Six years is the period within which a claim
                        may generally be brought under the Limitation Act 1980,
                        and it also satisfies our accounting and tax obligations.
                      </li>
                      <li>
                        Maintenance and service request records: six years from
                        completion of the request, so that any later claim about
                        the works can be answered.
                      </li>
                      <li>
                        Compliance certificates and health and safety records:
                        for the period required by the relevant legislation, and
                        in the case of records forming part of the safety
                        information for a building, for as long as that
                        legislation requires them to be held.
                      </li>
                      <li>
                        Enquiries and correspondence that do not form part of
                        your account record: two years from the date the matter
                        was closed.
                      </li>
                      <li>
                        Website analytics information: up to two years from your
                        visit.
                      </li>
                      <li>
                        Records of the notifications we send you about calendar
                        events: six years from the date of the event, so that we
                        can show who was told about a meeting and when.
                      </li>
                      <li>
                        Security records of sign-ins and of changes made to your
                        account details: six years from the date of the record.
                        These records show which details were changed, by whom
                        and when, but not the details themselves, and they may be
                        kept after your account is closed or deleted so that we
                        can investigate misuse and show how your account was
                        handled.
                      </li>
                    </ol>
                    <p>
                      {" "}
                      Where you ask us to delete your information and none of
                      the above requires us to keep it, we will do so within one
                      month. We will securely delete or anonymise your personal
                      information when it is no longer needed for the purposes
                      for which it was collected.
                    </p>
                    <li>Data Security</li>
                    <p>
                      {" "}
                      We implement appropriate technical and organisational
                      measures to protect your personal information against
                      unauthorised access, disclosure, alteration, or
                      destruction. Traffic between the Platform and our servers
                      is encrypted in transit, passwords are stored in a securely hashed form and are never visible to us, your sign-in
                      session is held in the secure storage provided by your
                      device's operating system, and access to your information
                      within the Platform is restricted according to the Role
                      you hold and your connection to the property. However,
                      please be aware that no method of transmission over the
                      internet or electronic storage is completely secure.
                      Therefore, while we strive to protect your personal
                      information, we cannot guarantee its absolute security.
                      You are responsible for keeping your sign-in details
                      confidential and for telling us promptly if you believe
                      your account has been accessed by someone else.
                    </p>
                    <li>Confidentiality of Our Staff and Contractors</li>
                    <p>
                      {" "}
                      Our employees, and anyone else acting under our authority
                      who has access to your personal information, are bound by
                      a duty of confidentiality in respect of that information.
                      Access is granted only to those who need it in order to
                      carry out their work, and only for as long as they need
                      it. This duty continues after their engagement with us
                      ends, and applies except where they are required by law to
                      disclose information.
                    </p>
                    <li>Cookies and Similar Technologies</li>
                    <ol>
                      <li>
                        The Website uses Google Analytics to understand how
                        visitors find and use the site, so that we can improve
                        it. Google Analytics sets two first-party cookies on
                        your device, named "_ga" and "_ga_" followed by a
                        property identifier. They store a randomly generated
                        identifier which allows repeat visits from the same
                        browser to be counted as one visitor. Both expire two
                        years after they are set.
                      </li>
                      <li>
                        We do not use cookies for advertising, and we do not
                        allow advertisers or other third parties to place their
                        own cookies on the Website.
                      </li>
                      <li>
                        You can block or delete cookies through your browser
                        settings, and you can opt out of Google Analytics across
                        all websites by installing the browser add-on Google
                        provides for that purpose. Blocking these cookies does
                        not affect your ability to use the Website.
                      </li>
                      <li>
                        The Quoin mobile application does not use cookies. It
                        stores your sign-in session in the secure storage
                        provided by your device's operating system, and stores
                        display preferences such as your chosen theme locally on
                        the device. Neither is shared with any third party, and
                        both are removed when you sign out or uninstall the
                        application. If you allow notifications, your device's
                        notification service gives the application an identifier
                        for your device, which we hold so that we can send you
                        notifications; we delete it when it stops working, for
                        example after you uninstall the application.
                      </li>
                    </ol>
                    <li>Your Rights</li>
                    <p>
                      {" "}
                      You have certain rights regarding your personal
                      information, including:
                    </p>
                    <ol>
                      <li>
                        Right to Access and Rectify: You have the right to
                        access and update your personal information held by us.
                        You can review and edit your account information by
                        logging into your account on our Website or in the
                        Quoin app, where you can update details such as your
                        email address, mobile number, date of birth and
                        password. If you need
                        assistance or have specific requests, please contact us
                        using the information provided below.
                      </li>
                      <li>
                        Right to Withdraw Consent: If you have provided your
                        consent for the processing of your personal information,
                        you have the right to withdraw your consent at any time.
                        This will not affect the lawfulness of the processing
                        based on consent before its withdrawal.
                      </li>
                      <li>
                        Right to Object: You have the right to object to the
                        processing of your personal information for certain
                        purposes, such as direct marketing. We will comply with
                        your request unless we have compelling legitimate
                        grounds for the processing that override your interests,
                        rights, and freedoms.
                      </li>
                      <li>
                        Right to Erasure: You have the right to request the
                        deletion or erasure of your personal information in
                        certain circumstances. We will comply with your request,
                        subject to any legal obligations or legitimate interests
                        that require us to retain certain information. Closing
                        your Platform account does not remove records we are
                        required to keep in order to administer your property or
                        to meet our legal and accounting obligations.
                      </li>
                      <li>
                        Right to Restrict Processing and Data Portability: You
                        have the right to ask us to restrict how we use your
                        personal information in certain circumstances, and to
                        receive the personal information you have provided to us
                        in a structured, commonly used and machine-readable
                        format.
                      </li>
                      <li>
                        Right to Lodge a Complaint: If you believe that we have
                        violated your privacy rights, you have the right to
                        lodge a complaint with a supervisory authority or data
                        protection authority. In the United Kingdom this is the
                        Information Commissioner's Office (www.ico.org.uk). We
                        would ask that you contact us first so that we have the
                        opportunity to put things right.
                      </li>
                    </ol>
                    <li>Automated Decision-Making</li>
                    <p>
                      {" "}
                      We do not make decisions that produce legal or similarly
                      significant effects about you by automated means alone.
                      The Platform calculates figures such as balances, arrears,
                      instalments and certificate expiry dates automatically,
                      but any decision taken as a result is made by a person.
                    </p>
                    <li>Children</li>
                    <p>
                      {" "}
                      The Services are intended for adults. Accounts on the
                      Platform are issued to people aged 18 or over, and we do
                      not knowingly collect personal information from children.
                      If you believe a child has provided us with personal
                      information, please contact us and we will delete it.
                    </p>
                    <li>Third-Party Websites</li>
                    <p>
                      {" "}
                      Our Website and the Platform may contain links to
                      third-party websites and services that are not operated by
                      us, including payment pages, meeting links and app stores.
                      We have no control over the content, privacy policies, or
                      practices of these websites. We encourage you to review
                      the privacy policies of any third-party websites you
                      visit.
                    </p>
                    <li>International Data Transfers</li>
                    <p>
                      {" "}
                      Our database is held in the United Kingdom, but the
                      servers that run the Platform are hosted by our cloud
                      hosting provider in the United States, so your personal
                      information is processed there when you use the Platform.
                      We may also transfer and store your personal information
                      outside your country of residence, including to
                      jurisdictions that may not provide the same level of data
                      protection as your home country. We will take appropriate
                      measures to ensure that such transfers comply with
                      applicable data protection laws — such as the use of
                      UK-approved safeguards (for example, the International Data
                      Transfer Agreement or the UK Addendum to the EU standard
                      contractual clauses) — and
                      that your personal information remains protected.
                    </p>
                    <li>Changes to this Privacy Policy</li>
                    <p>
                      {" "}
                      We reserve the right to modify or update this Privacy
                      Policy at any time. We will notify you of any material
                      changes by posting the revised Privacy Policy on our
                      Website and updating the "Effective Date" at the top of
                      this page. We encourage you to review this Privacy Policy
                      periodically to stay informed about how we collect, use,
                      and protect your personal information.
                    </p>
                    <li>Contact Us</li>
                    <p> Email: info@quoinmanagement.com</p>
                    <p> Phone: 020 8614 0767</p>
                    <p>
                      {" "}
                      Address: Quoin Estates Management Ltd, 30 Churchill Place, London
                      E14 5RE (company no. 13185366)
                    </p>
                  </ol>
                  <p>
                    We will respond to your enquiries and requests in a timely
                    manner.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SponsorV2 />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}

export default Privacy;
